var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "gfu-project-description-section gfu-project-description-section--emphasized",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "_tc--gray gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl",
          attrs: { "data-qa": "project-description-section:Adfound banner" },
        },
        [
          _c(
            "a",
            {
              attrs: {
                href: _vm.performanceMarketingUrlWithRef,
                target: "_blank",
                title:
                  _vm.Resources.ProjectHome.PerformanceMarketingBannerLabel,
              },
            },
            [_c("base-image", { attrs: { src: _vm.imgUrl } })],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }